// Hamb menu
$(document).ready(function() {
	$('#valet .dashboard .mobile-tabs li').click(function() {
		if ($(this).data('id') == 'send') {
			$('#valet .dashboard .filters').hide();
			$('#valet .dashboard .send').show();
		} else {
			$('#valet .dashboard .send').hide();
			$('#valet .dashboard .filters').show();
		}
		$('#valet .dashboard .mobile-tabs li').removeClass('active');
		$(this).addClass('active');
	});
	$(
		'select[name="month"], select[name="status"], select[name="phone"], select[name="batch_id"]'
	).change(function() {
		var url = window.location.href.split(/[?#]/)[0];
		var month = $('select[name="month"]').val();
		var phone = $('select[name="phone"]').val();
		var status = $('select[name="status"]').val();
		var batch_id = $('select[name="batch_id"]').val();
		if (month || phone || status || batch_id) {
			url += '?';
			if (batch_id) url += 'batch_id=' + batch_id + '&';
			if (month) url += 'month=' + month + '&';
			if (status) url += 'status=' + status + '&';
			if (phone) url += 'phone=' + phone + '&';
			url = url.slice(0, -1);
		}
		window.location.href = url;
	});

	$('#nav-bar input').on('input blur paste', function() {
		$(this).val(
			$(this)
				.val()
				.replace(/\D/g, '')
		);
	});

	$('#nav-bar .copy').click(function() {
		var dummy = document.createElement('input');
		var text = window.location.href;

		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
	});	

	$('.toggle-nav').on('click', function() {
		toggleNavigation($(this), $('.nav-pane'));
		changeLetters($(this));
	});

	function toggleNavigation(btn, nav) {
		btn.toggleClass('open');
		nav.toggleClass('open');
		$(
			'.homepage, .what-is-pave-page, .how-pave-works-page, .solutions-page, .get-started-page, .use-cases-page, .pave-creators-page, .press-page, .contact-page, #footer-wrapper'
		).toggleClass('home-pad');
	}

	function changeLetters(btn) {
		var e = $('.toggle-nav span.e');
		e.toggleClass('btn-close');
	}

	$('.modal-dynamic').on('show.bs.modal', function(event) {
		var button = $(event.relatedTarget);
		var title = button.data('title');
		var sessionId = button.data('id');
		var sessionKey = button.data('session');
		var input = button.data('input');
		var modal = $(this);
		modal.find('.modal-title').text(title + ' ' + sessionKey);
		modal.find('.session_id').val(sessionId);
		modal.find('.input_value').val(input);
	});

	$('[data-toggle="tooltip"]').tooltip();
});

$('li.dropdown').hover(
	function() {
		$(this)
			.find('.dropdown-menu')
			.stop(true, true)
			.delay(100)
			.fadeIn(200);
	},
	function() {
		$(this)
			.find('.dropdown-menu')
			.stop(true, true)
			.delay(100)
			.fadeOut(200);
	}
);

$('.dropdown a').removeAttr('data-target');

$(document).ready(function() {
	$('.login').click(function() {
		$('#login').show();
	});

	$('#login .body .exit').click(function() {
		$('#login').hide();
	});	

	// Capture images slider
	let $slider = $('.slider'),
		$slideBGs = $('.slide__bg'),
		diff = 0,
		curSlide = 0,
		numOfSlides = $('.slide').length - 1,
		animating = false,
		animTime = 500,
		autoSlideTimeout,
		autoSlideDelay = 6000,
		$pagination = $('.slider-pagi');

	function createBullets() {
		for (let i = 0; i < numOfSlides + 1; i++) {
			let $li = $("<li class='slider-pagi__elem'></li>");
			$li.addClass('slider-pagi__elem-' + i).data('page', i);
			if (!i) $li.addClass('active');
			$pagination.append($li);
		}
	}

	createBullets();

	function manageControls() {
		$('.slider-control').removeClass('inactive');
		if (!curSlide) $('.slider-control.left').addClass('inactive');
		if (curSlide === numOfSlides)
			$('.slider-control.right').addClass('inactive');
	}

	function autoSlide() {
		autoSlideTimeout = setTimeout(function() {
			curSlide++;
			if (curSlide > numOfSlides) curSlide = 0;
			changeSlides();
		}, autoSlideDelay);
	}

	autoSlide();

	function changeSlides(instant) {
		if (!instant) {
			animating = true;
			manageControls();
			$slider.addClass('animating');
			$slider.css('top');
			$('.slide').removeClass('active');
			$('.slide-' + curSlide).addClass('active');
			setTimeout(function() {
				$slider.removeClass('animating');
				animating = false;
			}, animTime);
		}
		window.clearTimeout(autoSlideTimeout);
		$('.slider-pagi__elem').removeClass('active');
		$('.slider-pagi__elem-' + curSlide).addClass('active');
		$slider.css('transform', 'translate3d(' + -curSlide * 100 + '%,0,0)');
		$slideBGs.css('transform', 'translate3d(' + curSlide * 50 + '%,0,0)');
		diff = 0;
		autoSlide();
	}

	function navigateLeft() {
		if (animating) return;
		if (curSlide > 0) curSlide--;
		changeSlides();
	}

	function navigateRight() {
		if (animating) return;
		if (curSlide < numOfSlides) curSlide++;
		changeSlides();
	}

	$(document).on('mousedown touchstart', '.slider', function(e) {
		if (animating) return;
		window.clearTimeout(autoSlideTimeout);
		let startX = e.pageX || e.originalEvent.touches[0].pageX,
			winW = $(window).width();
		diff = 0;

		$(document).on('mousemove touchmove', function(e) {
			let x = e.pageX || e.originalEvent.touches[0].pageX;
			diff = ((startX - x) / winW) * 70;
			if (
				(!curSlide && diff < 0) ||
				(curSlide === numOfSlides && diff > 0)
			)
				diff /= 2;
			$slider.css(
				'transform',
				'translate3d(' + (-curSlide * 100 - diff) + '%,0,0)'
			);
			$slideBGs.css(
				'transform',
				'translate3d(' + (curSlide * 50 + diff / 2) + '%,0,0)'
			);
		});
	});

	$(document).on('mouseup touchend', function() {
		$(document).off('mousemove touchmove');
		if (animating) return;
		if (!diff) {
			changeSlides(true);
			return;
		}
		if (diff > -8 && diff < 8) {
			changeSlides();
			return;
		}
		if (diff <= -8) {
			navigateLeft();
		}
		if (diff >= 8) {
			navigateRight();
		}
	});

	$(document).on('click', '.slider-control', function() {
		if ($(this).hasClass('left')) {
			navigateLeft();
		} else {
			navigateRight();
		}
	});

	$(document).on('click', '.slider-pagi__elem', function() {
		curSlide = $(this).data('page');
		changeSlides();
	});

	$('#points .list li').each(function() {
		$(this).hover(
			function() {
				$(this)
					.find('.icon')
					.addClass('pulse-icon');
			},
			function() {
				$(this)
					.find('.icon')
					.removeClass('pulse-icon');
			}
		);
	});
});

$('form.contact100-form.validate-form').submit(function(e) {
	e.preventDefault();
	$('.form-submit').removeClass('hide');
	$('.wrap-contact100').addClass('hide');
	e.currentTarget.submit();
});

$('#purchase .top .tabs li').click(function() {
	$('#purchase .top .tabs li').removeClass('active');
	$('#purchase .main').hide();

	$(this).addClass('active');
	$('#' + $(this).data('id')).show();
});

$('#purchase input[name="count"]').keyup(function() {
	var total = $(this).val();

	if (isNaN(total)) {
		alert('Numerical values only');
		return false;
	}

	$('#purchase .bulk .price strong').html(String(total * 15) + '.00');
});

$('button.show-confirm').click(function() {
	if (!confirm('Are you sure you want to continue?')) return false;
});

$('#valet .main .box .faq li .title').click(function() {
	$(this)
		.parent()
		.find('.copy')
		.slideToggle();
});
if ($('#valet .slides').length > 0) {
	var count = 1;

	setInterval(function() {
		$('#valet .slides .slide').hide();
		$('#valet .slides .slide[data-id="' + count + '"]').show();

		if (count >= 4) {
			count = 0;
		}

		count = count + 1;
	}, 5000);
}
